import * as React from "react";
import useSWR from "swr";
import fetcher from "./fetcher";

const baseEndpoint = "/api/talentDashboard/getPaidV2/invoices";

export default function useGetPaidInvoices(
  page = 1,
  pageSize = 10,
  influencerId = 0,
) {
  const url = React.useMemo(() => {
    const params = new URLSearchParams({
      page: String(page),
      page_size: String(pageSize),
    });
    if (influencerId) {
      params.set("influencer_id", String(influencerId));
    }
    return `${baseEndpoint}?${params.toString()}`;
  }, [page, pageSize, influencerId]);

  const { data, error, mutate, isValidating } = useSWR(url, fetcher, {
    keepPreviousData: true,
  });

  return {
    invoices: data?.invoices ?? [],
    pagination: data?.pagination ?? {
      page: 1,
      pageSize,
      total: 0,
      totalPages: 0,
    },
    isLoading: !data && !error,
    isValidating,
    error,
    refresh: mutate,
  };
}
